import styled from 'styled-components'

export const TitleRow = styled.div`
	display: flex;
	align-items: center;
	column-gap: 12px;
`
